// extracted by mini-css-extract-plugin
export var articleWrapper = "n_p8";
export var articleText = "n_p9 d_dv d_cs";
export var header = "n_qb d_Z d_w";
export var headerImageWrapper = "n_qc d_bd d_0 d_8 d_7 d_4 d_9 d_bk d_bR";
export var headerGradient = "n_qd d_bd d_0 d_8 d_7 d_4 d_9";
export var headerGradientOverlay = "n_qf d_bd d_0 d_8 d_7 d_4 d_9";
export var headerContentWrapper = "n_qg d_bz d_bP d_bD d_bJ d_bl d_Z";
export var headerContentWrapperAlt = "n_qh d_bz d_bP d_bD d_bJ d_bl d_Z";
export var contentWrapper = "n_mv d_w";
export var dateTag = "n_qj d_cf d_cr d_dq d_w";
export var icon1 = "n_qk d_cP";
export var icon2 = "n_ql d_cP d_cJ";
export var tagBtn = "n_qm d_b1 d_cD d_dp d_dB";
export var headerText = "n_qn d_w d_cf d_cs d_bW";
export var center = "n_qp d_dw";
export var videoIframeStyle = "n_qq d_d5 d_w d_H d_by d_b1 d_R";
export var articleImageWrapper = "n_qr d_cs d_Z";
export var articleImageWrapperIcon = "n_qs d_cs d_Z";
export var articleRow = "n_qt d_bD";
export var quoteWrapper = "n_gQ d_bC d_bP d_cs";
export var quoteBar = "n_qv d_H";
export var quoteText = "n_qw";
export var authorBox = "n_qx d_w";
export var authorRow = "n_qy d_bD d_bW d_cy";
export var separator = "n_qz d_w";
export var line = "n_fk d_w d_fk d_cY d_cy";
export var authorImage = "n_ln d_b7 d_Z d_w d_ct";
export var authorText = "n_qB d_ch d_ct";
export var masonryImageWrapper = "n_qC";
export var bottomSeparator = "n_qD d_w d_cy";
export var linksWrapper = "n_qF d_ch d_dv";
export var comments = "n_qG d_bD d_cy";
export var sharing = "n_qH d_bz d_bD d_bJ";
export var shareText = "n_qJ d_w d_dw";
export var icon = "n_qK";
export var customRow = "n_qL d_bD d_Z";
export var text = "n_qM";
export var SubtitleSmall = "n_qN";
export var SubtitleNormal = "n_qP";
export var SubtitleLarge = "n_qQ";